module.exports = __webpack_public_path__ + "assets/img/img_2019.e2af0c87.jpg";